// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.div-table {
    display: table;
    width: 100%;
    border-spacing: 5px; /* cellspacing:poor IE support for  this */
    overflow:hidden;
}

.div-table-row {
    display: table-row;
    width: auto;
    clear: both;
}

.div-table-col {
    float:left;
    display: table-column;
    width: 200px;
}
.header-row {
    border-bottom:1px solid black;
    padding-bottom:10px;
    margin-bottom:10px;
}

.table-body {
    overflow: auto;
    height: calc(100% - 34px);
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/treetable/treetable.control.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB,EAAE,0CAA0C;IAC/D,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B","sourcesContent":[".div-table {\n    display: table;\n    width: 100%;\n    border-spacing: 5px; /* cellspacing:poor IE support for  this */\n    overflow:hidden;\n}\n\n.div-table-row {\n    display: table-row;\n    width: auto;\n    clear: both;\n}\n\n.div-table-col {\n    float:left;\n    display: table-column;\n    width: 200px;\n}\n.header-row {\n    border-bottom:1px solid black;\n    padding-bottom:10px;\n    margin-bottom:10px;\n}\n\n.table-body {\n    overflow: auto;\n    height: calc(100% - 34px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
